import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedMerchantInfoData } from "mappers";
import { chargebacksDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse, MerchantInfoDto, MerchantInfoMappedDto } from "types";

type useGetMerchantInfoByChargebackIdQueryProps = {
	chargebackId: string;
};

const useGetMerchantInfoByChargebackIdQuery = ({
	chargebackId,
}: useGetMerchantInfoByChargebackIdQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["chargebackMerchantInformation", chargebackId],
		() =>
			chargebacksDetailsService.getMerchantInfo({
				chargebackId,
			}),
		{
			select: (data: MerchantInfoDto): MerchantInfoMappedDto => {
				return getMappedMerchantInfoData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!chargebackId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetMerchantInfoByChargebackIdQuery;
